import { getRawId } from 'util/globalId'

function buildFolderKindsTypes({ currentUserId }) {
  return [
    {
      type: 'unassigned',
      conditions: [
        {
          param: 'assigned_agent',
          operators: ['eq'],
          value: null,
        },
        {
          param: 'assigned_group',
          operators: ['eq'],
          value: null,
        },
        {
          param: 'status',
          operators: ['lteq', 'eq'],
          value: 'opened',
        },
      ],
    },
    currentUserId && {
      type: 'mine',
      conditions: [
        {
          param: 'assigned_agent',
          operators: ['eq'],
          value: currentUserId,
        },
        {
          param: 'status',
          operators: ['lteq', 'eq'],
          value: 'opened',
        },
      ],
    },
  ].filter(f => !!f)
}

export function getFolderKind(folder, data) {
  return (
    buildFolderKindsTypes(data).find(folderType => {
      if (folder.conditions.length !== folderType.conditions.length) return null
      let isMatch = true
      folderType.conditions.some(folderTypeCondition => {
        isMatch = folder.conditions.some(folderCondition => {
          return (
            folderTypeCondition.param === folderCondition.param &&
            folderTypeCondition.value === folderCondition.value &&
            folderTypeCondition.operators.includes(folderCondition.operator)
          )
        })
        return !isMatch
      })
      return isMatch ? folderType : null
    })?.type || null
  )
}

export function filterByActiveAndMailboxId(mailboxId) {
  return folder => {
    return (
      folder.state === 'ACTIVE' &&
      Object.values(folder.channels).some(
        ({ id: channelId }) => getRawId(channelId) === getRawId(mailboxId)
      )
    )
  }
}
